// extracted by mini-css-extract-plugin
export default {"MatomoStatistics":"MatomoStatistics_MatomoStatistics__2+2yJ"};